var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7757 2.86963L10.0725 0.219914C9.93002 0.0799015 9.73684 0.000849844 9.53513 6.81213e-06C9.33342 -0.00083622 9.13955 0.0765978 8.99584 0.215414L2.36749 6.61509C2.26417 6.71539 2.19181 6.84225 2.15873 6.98109L1.37568 10.3088L0 12H2.16255L3.03583 11.1533L5.77954 10.5323C5.91719 10.5008 6.04336 10.4326 6.1443 10.3358L12.7719 3.93462C12.8438 3.86515 12.901 3.7824 12.9401 3.69114C12.9793 3.59988 12.9996 3.50192 13 3.40291C13.0004 3.3039 12.9807 3.2058 12.9422 3.11428C12.9037 3.02275 12.8471 2.9396 12.7757 2.86963ZM5.61131 8.74432L3.9894 7.15434L9.52806 1.80615L11.1492 3.39613L5.61131 8.74432ZM0 13.5H12.2351V15H0V13.5Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.2de7c589ed5aa01f9e374aed0ff8b894.svg";
export { ForwardRef as ReactComponent };